"use client";

import dynamic from "next/dynamic";

// Dynamically import ImpersonationBanner to avoid SSR issues
const ImpersonationBanner = dynamic(
  () => import("./impersonation-banner").then(mod => ({ default: mod.ImpersonationBanner })),
  { ssr: false }
);

export function ImpersonationBannerWrapper() {
  return <ImpersonationBanner />;
}
